var generateChatName = function (newChats) {
    var currentIndex = newChats.reduce(function (acc, _a) {
        var name = _a.name;
        var match = name.match(/Chat (\d+)/);
        if (match) {
            var index = parseInt(match[1], 10);
            return index > acc ? index : acc;
        }
        return acc;
    }, 0);
    return "Chat ".concat(currentIndex + 1);
};
export default generateChatName;
